var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{staticClass:"width-100 height-100 flex-centerize"},[_c('h5',{staticClass:"description-text mb-5"},[_vm._v("Hover over the notification to see call to action and links")]),_c('BuilderNotification',{attrs:{"icon":_vm.icon,"title":_vm.title,"additionalInfo":_vm.additionalInfo,"takeActionTitle":_vm.takeActionTitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }